<script lang="ts">
	import LoadingChasing from '../LoadingChasing.svelte'
	import type { AuthStatus } from '$lib_commons/models/auth.ts'

	interface Props {
		status: AuthStatus
		errorMessage?: string
		children?: import('svelte').Snippet | null
		loading?: import('svelte').Snippet | null
		error?: import('svelte').Snippet | null
	}

	let {
		status,
		errorMessage = 'Authentication failed. Please try again.',
		children = null,
		loading = null,
		error = null
	}: Props = $props()
</script>

{#if status === 'loading'}
	{#if loading}
		{@render loading()}
	{:else}
		<div class="auth-gate-loading">
			<LoadingChasing />
		</div>
	{/if}
{:else if status === 'error'}
	{#if error}
		{@render error()}
	{:else}
		<div class="auth-gate-error">
			{errorMessage}
		</div>
	{/if}
{:else if children}
	{@render children()}
{/if}

<style lang="postcss">
	.auth-gate-loading,
	.auth-gate-error {
		@apply flex items-center justify-center h-screen;
	}

	.auth-gate-error {
		@apply text-red-500;
	}
</style>
